import { Box, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import BigStar from '../../../../assets/images/register/big-star.png';
import SmallStar from '../../../../assets/images/register/small-star.png';
import Shape from '../../../../assets/images/register/shape.png';
import Coins from '../../../../assets/images/register/coins.png';
import SmallCoin from '../../../../assets/images/register/small-coin.png';

import PAYOUT_1 from '../../../../assets/images/register/PAYOUT_1.png';
import PAYOUT_2 from '../../../../assets/images/register/PAYOUT_2.png';
import PAYOUT_3 from '../../../../assets/images/register/PAYOUT_3.png';
import PAYOUT_4 from '../../../../assets/images/register/PAYOUT_4.png';
import PAYOUT_5 from '../../../../assets/images/register/PAYOUT_5.png';

import {
  bgWrapperSx,
  bigStarImgSx,
  coinsImgSx,
  coinsWrapperSx,
  contentStackSx,
  heroRootSx,
  marqueeInnerSx,
  marqueeOuterSx,
  marqueeRowProps,
  marqueeRowSx,
  shapeImgSx,
  smallCoinImgSx,
  smallStarImgSx,
  subtitleSx,
  textGroupSx,
  titleSx,
} from './styles';

const payoutImages = [PAYOUT_1, PAYOUT_2, PAYOUT_3, PAYOUT_4, PAYOUT_5];
const loopedPayouts = [...payoutImages, ...payoutImages];

const HeroContent = () => {
  const { t } = useTranslation('heroContent');

  return (
    <Stack sx={heroRootSx}>
      <Stack sx={bgWrapperSx}>
        <Box component="img" src={BigStar} sx={bigStarImgSx} />
        <Box component="img" src={SmallStar} sx={smallStarImgSx} />
        <Box component="img" src={Shape} sx={shapeImgSx} />
      </Stack>

      <Stack sx={contentStackSx}>
        <Box sx={textGroupSx}>
          <Box sx={coinsWrapperSx}>
            <Box component="img" src={Coins} sx={coinsImgSx} />
            <Box component="img" src={SmallCoin} sx={smallCoinImgSx} />
          </Box>
          <Stack>
            <Typography sx={titleSx}>{t('TITLE')}</Typography>
            <Typography sx={subtitleSx}>{t('SUBTITLE')}</Typography>
          </Stack>
        </Box>
      </Stack>

      <Box sx={marqueeOuterSx}>
        <Box sx={marqueeInnerSx}>
          <Stack {...marqueeRowProps} sx={marqueeRowSx}>
            {loopedPayouts.map((src, idx) => (
              <Box
                key={idx}
                component="img"
                src={src}
                sx={{
                  height: 180,
                  width: 'auto',
                  borderRadius: '8px',
                }}
              />
            ))}
          </Stack>
        </Box>
      </Box>
    </Stack>
  );
};

export default HeroContent;
